import { AbstractControl, FormGroup } from '@angular/forms';
import {
    CompleteSortieCommand,
    DisplayableMissionDto,
    SortieDto
} from '@flyfreely-portal-ui/flyfreely';
import { BehaviorSubject, Observable } from 'rxjs';
import { DisplayableResource } from '../mission-completion.service';

/**
 * This defines the interface that is used to provide central functions from the mission completion services
 */
export abstract class MissionCompletionOrRecordService<
    T extends { [K in keyof T]: AbstractControl<any> } = any
> {
    private selectedPilotsSubject = new BehaviorSubject<DisplayableResource[]>(
        []
    );
    /**
     * The pilots selected on flights. They can come from outside the mission plan, in which case they aren't in availablePersonnel$.
     */
    selectedPilots$ = this.selectedPilotsSubject.asObservable();

    abstract availablePersonnel$: Observable<DisplayableResource[]>;
    abstract working$: Observable<boolean>;
    abstract savedMission$: Observable<DisplayableMissionDto>;
    abstract form: FormGroup<T>;
    abstract updateMissionFromSortieCommand(
        sortieCommand: CompleteSortieCommand[],
        mission: DisplayableMissionDto
    ): Observable<DisplayableMissionDto>;
    abstract updateFlights(flights: SortieDto[]): void;
    abstract addFlight(flight: SortieDto): void;
    abstract updateFlight(flight: SortieDto): void;

    addSelectedPilots(pilots: DisplayableResource[]) {
        const selectedPilots = this.selectedPilotsSubject.getValue();
        const newPilots = pilots.filter(
            pilot => selectedPilots.findIndex(p => p.id === pilot.id) === -1
        );
        if (newPilots.length > 0) {
            this.selectedPilotsSubject.next(selectedPilots.concat(newPilots));
        }
    }
}
